import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { NavLink, Redirect, Route, useRouteMatch } from 'react-router-dom';
import { Actions } from '../../../Actions/Actions';
import api from '../../../seller-apis/api'
import { revokedOnly } from '../../../seller-apis/apidataField'
import Revoked_Delivered from './Revoked_Delivered';
import Revoked_InTransit from './Revoked_InTransit'
import moment from 'moment';
import { resetOrderDateFilter, REVOKED_ORDER_DATE_DAYS } from '../useOrderDateAlert';

var dateFromWeb = moment().subtract(30, 'days').format('YYYY-MM-DD');
var dateToWeb = moment().format('YYYY-MM-DD');

const Revoked = () => {

    const { path, url } = useRouteMatch()
    const [transitRec, settransitRec] = useState();
    const [deliveredRec, setdeliveredRec] = useState();
    const dispatch=useDispatch();
    let rtoCount={
      intransit:null,
      delivered:null
    }
    useEffect(() => {
        const { from, to } = resetOrderDateFilter();
        dateFromWeb = from;
        dateToWeb = to;
      
        api.order.revokedOrders(revokedOnly({
            "pageNo": 1,
            "size": 1,
            "spclFilter": {
              // "products.tracks.rStatus-Id": "RTO-InTransit"
              "products.tracks.rStatus" : { "$ne": "RTO-Delivered" },
              "status": {"$in": ["RTO", "Partially delivered/RTO"]},
              "from-rtoDate": dateFromWeb + 'T00:00:00',
              "to-rtoDate": dateToWeb + 'T23:59:59'
            }
          })).then((res) => {
            settransitRec(res.totalRecords)
            rtoCount['intransit']=res.totalRecords;
            Actions.RTOCountAction(dispatch,rtoCount);
          }).catch(err => {
            console.log(err)
          })

    const fetchVendorAddress = () => {
        const addressBody = {
            "filter": {},
            "excludeField": {},
            "pageNo": 1,
            "sortFilter": {},
        }
        api.seller.getSellerAddress(addressBody).then((res) => {
            Actions.updateSellerAddress(dispatch, { data: res.data });
        }).catch(err => {
            console.log(err)
        });
    }
    }, [])


    return (
        <>

            {/* <div className='filter_options_invent order_nav_cntn d-flex tab mt-3'>
                <NavLink exact to={`${url}/delivered`} className="invent_nav"><button className='filter_options_btn_invent_new me-2' >RTO Delivered ({deliveredRec})</button></NavLink>
                <NavLink exact to={`${url}/in_transit`} className="invent_nav"><button className='filter_options_btn_invent_new me-2' >RTO InTransit ({transitRec})</button></NavLink>
            </div> */}
            <div>
                <Route exact path="/my-order/rto">
                    <Redirect to={`${path}/delivered`} />
                </Route>
                <Route path={`${path}/delivered`} component={Revoked_Delivered} />
                <Route path={`${path}/in_transit`} component={Revoked_InTransit} />
            </div>
        </>
    )
}

export default Revoked;